import Heading from '~/components/Shared/Heading/Heading';
import Page from '~/components/Shared/Layout/Page/Page';
import { ButtonLink } from '~/ui';
import { AccommodationsBoard } from './AccommodationsBoard/AccommodationsBoard';
import { checkIfUserSuperAdmin } from '~/utils/getUserRole';
import { AuthenticationContext } from '~/components/Authentication/AuthenticationProvider';
import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { XlsBtn } from '~/ui';
import { ReportDrawer } from '~/components/ReportDrawer/ReportDrawer';
import { AccommodationReportExtra } from './AccommodationReportExtra/AccommodationReportExtra';
import { downloadReportWithFields } from '~/utils/downloadReportFile';

const Accomodations = (): JSX.Element => {
  const { user } = useContext(AuthenticationContext);
  const isCreateButtonShown = checkIfUserSuperAdmin(user?.data.role_name);
  const { t } = useTranslation();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [reportType, setReportType] = useState<string>(
    'accommodation_analytics_all_export'
  );
  const [startDate, setStartDate] = useState<import('dayjs').Dayjs | null>(
    null
  );
  const [endDate, setEndDate] = useState<import('dayjs').Dayjs | null>(null);

  const getReportPathAndName = () => {
    const isAll = reportType === 'accommodation_analytics_all_export';
    return {
      path: isAll ? 'analytics-accommodation-all' : 'analytics-accommodation-statistics',
      name: isAll ? 'analytics-accommodation' : 'analytics-accommodation-details',
    };
  };

  const currentFilters = {
    start_date: startDate
      ?.hour(0)
      .minute(0)
      .second(1)
      .format('YYYY-MM-DD HH:mm:ss'),
    end_date: endDate?.endOf('day').format('YYYY-MM-DD HH:mm:ss'),
  };

  const handleExport = async (fields: string[]) => {
    const { path, name } = getReportPathAndName();
    await downloadReportWithFields(path, name, {
      ...currentFilters,
      fields,
    });
  };

  const handlePresetExport = async (presetId: number) => {
    const { path, name } = getReportPathAndName();
    await downloadReportWithFields(path, name, { preset_id: presetId });
  };

  return (
    <Page
      heading={
        <Heading
          text={t('accommodation_facilities')}
          actions={
            <>
              {isCreateButtonShown && (
                <ButtonLink
                  text={t('add_new_object')}
                  to="/accommodations/create"
                />
              )}
              <XlsBtn
                onClick={() => setDrawerOpen(true)}
                xlsBtnText={t('analytics_on_placements')}
              />
            </>
          }
        />
      }
    >
      <AccommodationsBoard />
      <ReportDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        reportType={reportType}
        onExport={handleExport}
        onPresetExport={handlePresetExport}
        isExportDisabled={!startDate || !endDate}
        extraParams={currentFilters}
        title={t('analytics_on_placements')}
        extraContent={
          <AccommodationReportExtra
            reportType={reportType}
            onReportTypeChange={setReportType}
            startDate={startDate}
            endDate={endDate}
            onStartDateChange={setStartDate}
            onEndDateChange={setEndDate}
          />
        }
      />
    </Page>
  );
};

export default Accomodations;
